(function () {
    'use strict';

    function initPopupImage(popup) {
        var storageKey = popup.getAttribute('data-storage-key');
        var mode = popup.getAttribute('data-mode');
        var intervalHours = parseFloat(popup.getAttribute('data-interval-hours')) || 24;
        var overlay = popup.querySelector('[data-popup-image-overlay]');
        var closeBtn = popup.querySelector('[data-popup-image-close]');
        var trigger = popup.querySelector('[data-popup-image-trigger]');

        function shouldShow() {
            try {
                if (mode === 'once') {
                    var seen = localStorage.getItem(storageKey + ':seen');
                    return !seen;
                }

                if (mode === 'interval') {
                    var lastClosed = localStorage.getItem(storageKey + ':last-closed');
                    if (!lastClosed) return true;

                    var elapsedMs = Date.now() - parseInt(lastClosed, 10);
                    var elapsedHours = elapsedMs / (1000 * 60 * 60);
                    return elapsedHours >= intervalHours;
                }

                if (mode === 'every_visit') {
                    // sessionStorage is cleared when the tab/browser is closed,
                    // so this re-shows the popup on every new browsing session
                    // but stays hidden after close for the rest of the current session.
                    var closedThisSession = sessionStorage.getItem(storageKey + ':closed-session');
                    return !closedThisSession;
                }

                return false;
            } catch (e) {
                // storage unavailable (e.g. private mode restrictions) - fail safe, don't show
                return false;
            }
        }

        function markClosed() {
            try {
                if (mode === 'once') {
                    localStorage.setItem(storageKey + ':seen', '1');
                } else if (mode === 'interval') {
                    localStorage.setItem(storageKey + ':last-closed', Date.now().toString());
                } else if (mode === 'every_visit') {
                    sessionStorage.setItem(storageKey + ':closed-session', '1');
                }
            } catch (e) {
                // ignore storage errors
            }
        }

        function show() {
            popup.classList.add('is-visible');
            popup.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        }

        function hide() {
            popup.classList.remove('is-visible');
            popup.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }

        function close() {
            markClosed();
            hide();
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                close();
            });
        }

        if (overlay) {
            overlay.addEventListener('click', close);
        }

        if (trigger) {
            trigger.addEventListener('click', function () {
                // Mark as closed/seen so it doesn't reopen on back-navigation,
                // but allow the link navigation itself to proceed.
                markClosed();
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
                close();
            }
        });

        if (shouldShow()) {
            // Small delay so it doesn't fight with initial page render/layout shift.
            window.setTimeout(show, 600);
        }
    }

    function init() {
        var popups = document.querySelectorAll('[data-popup-image]');
        popups.forEach(initPopupImage);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
